import { MARKETING_STATS } from '@/modules/auth/ui/components'

const SHOWCASE_STATS = [
  { value: MARKETING_STATS.birdsLogged, label: 'Birds Logged' },
  { value: MARKETING_STATS.huntsLogged, label: 'Hunts' },
  { value: MARKETING_STATS.speciesLogged, label: 'Species' },
] as const

export function RegisterShowcase() {
  return (
    <aside
      data-testid="register-showcase"
      className="relative hidden overflow-hidden md:order-2 md:flex md:h-screen md:w-[30%] md:min-w-[280px] md:flex-col md:items-center md:justify-center"
    >
      <img
        src="/hunter_hero.jpg"
        alt=""
        aria-hidden
        className="absolute inset-0 size-full object-cover brightness-[0.35] saturate-[0.7]"
      />
      <div
        aria-hidden
        className="absolute inset-0"
        style={{
          background:
            'linear-gradient(to bottom, rgba(18,26,19,0.3) 0%, rgba(18,26,19,0.6) 50%, rgba(18,26,19,0.92) 100%)',
        }}
      />
      <div className="relative z-10 flex max-w-[520px] flex-col items-center gap-7 px-10 py-12 text-center xl:gap-8">
        <img
          src="/blindbook-logo.svg"
          alt="BlindBook"
          width={96}
          height={96}
          className="size-20 brightness-0 invert xl:size-24"
        />
        <h2 className="text-4xl font-extrabold leading-[1.12] text-foreground xl:text-5xl">
          The Ultimate Waterfowl Hunting <span className="text-primary">Management System.</span>
        </h2>
        <p className="max-w-[440px] text-base leading-[1.6] text-muted-foreground xl:text-lg">
          Replaces the spreadsheets, group texts, and guesswork — so outfitters, clubs, lease squads,
          and hunters can focus on what matters: the hunt.
        </p>
        <div className="mt-2 flex w-full gap-3 xl:gap-4">
          {SHOWCASE_STATS.map((stat) => (
            <div
              key={stat.label}
              className="flex-1 rounded-xl border border-white/10 bg-white/5 px-3 py-5 xl:px-4 xl:py-6"
            >
              <div className="text-2xl font-extrabold text-foreground xl:text-3xl">{stat.value}</div>
              <div className="mt-1 text-sm text-muted-foreground xl:text-base">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </aside>
  )
}
